export const testIds = {
  qualityScoreHelperScore: 'quality-score-helper-score',
  qualityScoreCheckMetadata: 'quality-score-check-metadata',
  qualityScoreCheckResults: 'quality-score-check-results',
};

export const qualityScoreHelperDetailsTitle = 'Quality Score Helper Details';
